import HomeworkHelper from './components/HomeworkHelper';

function App() {
  return (
    <div className="min-h-screen bg-gray-100">
      <HomeworkHelper />
    </div>
  );
}

export default App;
